export interface IPrice {
  title?: string;
  amount: number;
  currency?: 'EUR' | 'RUB' | 'USD';
}
